import { BrandMark, BrandWordmark } from "@/components/BrandLogo";

/**
 * Branded Suspense fallback for lazily loaded routes.
 * variant="page"   → full-screen (used outside layouts: auth, public pages)
 * variant="content"→ skeleton for the content area inside Artist/Admin layouts
 */
export default function RouteFallback({ variant = "page" }) {
  if (variant === "content") {
    return (
      <div className="w-full space-y-6 p-1 animate-fade-up" role="status" aria-live="polite" aria-busy="true">
        <span className="sr-only">Loading…</span>
        <div className="flex items-end justify-between gap-4">
          <div className="space-y-2">
            <div className="shimmer h-8 w-56 rounded-lg" />
            <div className="shimmer h-4 w-80 max-w-[70vw] rounded-md" />
          </div>
          <div className="shimmer hidden h-10 w-32 rounded-xl sm:block" />
        </div>
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
          {[0, 1, 2, 3].map((i) => (
            <div key={i} className="shimmer h-28 rounded-2xl" />
          ))}
        </div>
        <div className="grid gap-4 lg:grid-cols-3">
          <div className="shimmer h-72 rounded-2xl lg:col-span-2" />
          <div className="shimmer h-72 rounded-2xl" />
        </div>
      </div>
    );
  }

  return (
    <div
      className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="brand-glow h-72 w-72 bg-primary/30" style={{ top: "30%", left: "45%" }} aria-hidden="true" />
      <div className="relative flex flex-col items-center gap-5">
        <div className="relative">
          <span className="absolute inset-0 rounded-2xl bg-primary/40 blur-xl animate-pulse" aria-hidden="true" />
          <BrandMark size="xl" className="relative" />
        </div>
        <BrandWordmark sizeClass="text-xl" className="text-foreground/90" />
        <div className="h-1 w-40 overflow-hidden rounded-full bg-muted">
          <div className="h-full w-1/3 rounded-full bg-gradient-to-r from-primary to-gold animate-[route-progress_1.1s_ease-in-out_infinite]" />
        </div>
        <span className="sr-only">Loading…</span>
      </div>
      <style>{`@keyframes route-progress{0%{transform:translateX(-110%)}100%{transform:translateX(330%)}}`}</style>
    </div>
  );
}
